import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import SurplusMaterialTable from "./Table/SurplusMaterialTable";
import { ShowHideTable } from "../../components/ShowHideTable";
const SurplusMaterialContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("TREATMENT_INGOING_PACKAGING")}
        isNormal={true}
        number={"8.1.2"}
      />
      {showTable && (
        <SurplusMaterialTable
          businessId={businessId}
          subcategory={"Treatment of ingoing delivery-packaging"}
          subcategory_description={""}
        />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default SurplusMaterialContents;
